module.exports = __webpack_public_path__ + "img/icon-smartwatch-gray-with-shield.538a61ce.svg";